import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from 'react-i18next';
import ISONumber from "components/formatting/ISONumber";
import ISOPercentage from "components/formatting/ISOPercentage";

interface SubqueriesKeywordTooltipProps {
  bucket: any;
  percentage: number;

  rootBucket: any;
  rootPercentage: number;
}

export default function SubqueriesKeywordTooltip(props: SubqueriesKeywordTooltipProps): JSX.Element {
  const { i18n } = useTranslation();
  const theme = useTheme();

  const { bucket, rootBucket, percentage, rootPercentage }: SubqueriesKeywordTooltipProps = props;

  const pctDiff = parseFloat(((percentage - rootPercentage) * 100.0).toFixed(1));

  let color = "inherit";
  if (pctDiff > 10) {
    color = theme.colors.namedColors.positiveDark;
  } else if (pctDiff > 1) {
    color = theme.colors.namedColors.positive;
  } else if (pctDiff < -10) {
    color = theme.colors.namedColors.negativeDark;
  } else if (pctDiff < -1) {
    color = theme.colors.namedColors.negative;
  }


  return (
    <Box>
      <Typography variant="h4" sx={{ textAlign: "center", fontWeight: "bold", mb: 1 }}>
        {bucket._label}
      </Typography>
      <Box sx={{ display: "grid", width: "100%", gridTemplateColumns: "auto auto auto", gap: "3px 10px", textAlign: "right", alignItems: "bottom" }}>
        <Box></Box>
        <Box>{i18n.t("records")}</Box>
        <Box>{i18n.t("percent")}</Box>

        <Box>
          <Typography variant="body2">
            {i18n.t("widget-types.subqueries.subquery")}
          </Typography>
        </Box>
        <Box>
          <ISONumber number={bucket._count} sx={{ fontWeight: "bold", color: theme.palette.primary.main }}/>
        </Box>
        <Box>
          <ISOPercentage hideTooltip={true} value={percentage} sx={{ fontWeight: "bold", color: theme.palette.primary.main }}/>
        </Box>

        <Box>
          <Typography variant="body2">
            {i18n.t("widget-types.subqueries.original")}
          </Typography>
        </Box>
        <Box>
          <ISONumber number={rootBucket._count} sx={{ fontWeight: "bold", color: theme.palette.primary.main }}/>
        </Box>
        <Box>
          <ISOPercentage hideTooltip={true} value={rootPercentage} sx={{ fontWeight: "bold", color: theme.palette.primary.main }}/>
        </Box>
      </Box>
      <Typography sx={{ textAlign: "center", mt: 1 }}>
        {i18n.t("widget-types.subqueries.percent-change")}
      </Typography>
      <Box sx={{textAlign: "center", fontWeight: "bold", fontSize: "1.5em", color: color}}>
        {pctDiff > 0 ? "+" : ""}
        {pctDiff}
      </Box>
    </Box>
  );
}
